import { createGraphQLApiProvider as createProvider } from '@stitch-fix/graphql-api-provider';
import { getWindow } from '../../../helpers/getBrowserGlobals';

const createGraphQLApiProvider = () =>
  createProvider({
    name: `knit:web`,
  }).GraphQLApiProvider;

let cachedProvider: ReturnType<typeof createGraphQLApiProvider>;

export const getGraphQLApiProvider = () => {
  if (!getWindow()) {
    // SSR - always return a new provider to avoid sharing personal data, and potential memory leaks
    return createGraphQLApiProvider();
  }

  // Browser - use a singleton provider to avoid losing the cache on component remounts
  cachedProvider ||= createGraphQLApiProvider();

  return cachedProvider;
};
